// AI Generated File
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { HeatmapApiService } from '@client/app/services/entities/heatmaps/heatmaps.service';
import { SessionService } from '@monsido/core/session/session.service';
import { HeatmapService } from '@client/app/modules/heatmaps/services/heatmap.service';

@Component({
    selector: 'heatmaps-dashboard-grid',
    standalone: false,
    template: `
        <mon-spinner [loading]="loading">
            <heatmaps-dialogs-pages
                [show]="showSearch"
                [selectedRule]="selectedRule"
                [rules]="rules"
                (close)="onClosePageSearch($event)">
            </heatmaps-dialogs-pages>
            <div class="row heatmap-dashboard-grid">
                <div class="col-lg-16" *ngFor="let rule of rules; let i = index">
                    <div class="card panel-monsido-card">
                        <div class="card-body d-flex align-items-center py-0 px-0">
                            <div class="text-ellipsis mx-2">
                                <div class="text-ellipsis">
                                    <p [attr.data-test]="'rule-' + rule.page.title | e2eAttributeEncoding" class="text-ellipsis font-size-1-1 my-0">
                                        {{rule.page.title}}
                                    </p>
                                    <p class="text-ellipsis my-0">
                                        <a [href]="rule.page.url" target="_blank" [attr.aria-describedby]="'linkOpensInNewTab'">
                                            <span class="fa-fw fas fa-external-link-alt pr-1"
                                                  aria-hidden="true">
                                            </span>
                                            <span class="sr-only">{{rule.page.url}}</span>
                                        </a>
                                        <span class="link-tooltip">{{rule.page.url}}</span>
                                    </p>
                                </div>
                                <div class="card-divider"></div>
                                <div class="text-ellipsis">
                                    <a [href]="domains[rule.id]?.url"
                                       target="_blank" [attr.aria-describedby]="'linkOpensInNewTab'">
                                        <span class="sr-only">
                                            {{domains[rule.id]?.url}}
                                        </span>
                                        <span class="fa-fw fas icon fa-external-link-alt"
                                              aria-hidden="true">
                                        </span>
                                    </a>
                                    <span class="fa-fw fa-globe fas" aria-hidden="true">
                                    </span>
                                    <span>{{domains[rule.id]?.title}}</span>
                                </div>
                            </div>
                            <div class="ml-auto d-flex align-items-stretch action-btn-group" *ngIf="['customer_admin'] | monRole">
                                <div class="align-items-stretch d-flex">
                                    <mon-extension-visual-link-button [page]="rule.page" [type]="'heatmaps'"></mon-extension-visual-link-button>
                                </div>
                                <div class="btn-group-vertical d-flex flex-column align-items-stretch" role="group">
                                    <button [attr.data-test]="'edit-page-button-' + rule.page.title | e2eAttributeEncoding" class="btn btn-border-radius btn-secondary py-3 px-4" type="button" (click)="editRule(rule)">
                                        <span class="fas fa-edit fa-lg fa-fw" aria-hidden="true"></span>
                                    </button>
                                    <button [attr.data-test]="'delete-page-button-' + rule.page.title | e2eAttributeEncoding" class="btn btn-border-radius btn-secondary py-3 px-4" type="button" (click)="removeRule(rule, i)">
                                        <span class="fas fa-trash-alt fa-lg fa-fw" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-container *ngFor="let rule of getLeftOverRules(); let i = index; trackBy: trackByLeftOverRules">
                    <div *ngIf="['customer_admin'] | monRole"
                         class="col-lg-16">
                        <div class="card panel-monsido-card">
                            <div class="card-body d-flex align-items-center py-0 px-0">
                                <div class="ml-auto">
                                    <div class="btn-group d-flex align-items-stretch" role="group">
                                        <button data-test="add-page-button" class="btn btn-border-radius btn-secondary py-6 px-4" type="button" (click)="addRule()">
                                            <span class="fas fa-plus fa-lg fa-fw" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </mon-spinner>
    `,
})
export class HeatmapsDashboardGridComponent implements OnInit {
    @Input() rules: any;
    @Input() loading: any;
    @Input() domains: any;
    @Output() getPage = new EventEmitter<any>();

    showSearch: boolean = false;
    selectedRule: any = null;

    constructor (
        private heatmapApiService: HeatmapApiService,
        private sessionService: SessionService,
        private heatmapService: HeatmapService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.showSearch = false;
        this.selectedRule = null;
    }

    editRule (rule: any): void {
        this.showSearch = true;
        this.selectedRule = rule;
    }

    addRule (): void {
        this.showSearch = true;
        this.selectedRule = null;
    }

    removeRule (rule: any, index: number): void {
        this.heatmapService.confirmDelete(rule).then(() => {
            this.heatmapApiService.destroy(rule.domain_id, rule.id).then(() => {
                this.rules.splice(index, 1);
            }, () => {});
        }, () => {});
    }

    getLeftOverRules (): any[] {
        if (this.sessionService.customer && this.sessionService.customer.plan_traits.heatmaps_tracked_number_of_pages > this.rules.length) {
            return new Array(this.sessionService.customer.plan_traits.heatmaps_tracked_number_of_pages - this.rules.length);
        }

        return new Array(0);
    }

    onClosePageSearch (rule: any): void {
        if (rule || (rule && this.selectedRule)) {
            this.getPage.emit();
        }
        this.showSearch = false;
        this.selectedRule = null;
    }

    trackByLeftOverRules (index: number, item: any): number {
        return index;
    }
}
